import { push } from 'connected-react-router'
import { showModal } from './_modal'
import { fetchArtifactAssessmentCriteria } from './assessment'
import { userIsLoggedInDataFetched, userIsLoggedInRedirected, userNeedsToResetPassword } from './auth'
import { fetchManifest } from './manifest'
import { fetchMentorNotifications } from './mentordashboard'
import { setCourseFilter } from './mystudents'
import { fetchPoliciesIfNeeded } from './policies'
import { fetchUserCourses } from './usercourses'
import { fetchUsers } from './users'
import { fetchAcademicYears } from './academicyears'
import { fetchClassRooms } from './classrooms'
import { fetchClassPeriods } from './classperiods'
import { fetchMyQuests } from './myquests'
import { fetchUnreadAnnouncementsCount } from './announcements'

export function fetchDataAndRedirectUser(
  user: Object,
  currentOrg: Object,
  isMentor: boolean,
  isGuardian: boolean
): Function {
  return async (dispatch, getState) => {
    const acceptedPoliciesCount = Object.keys(user.policies_acceptance).length
    const urlParams = new URLSearchParams(window.location.search)
    let redirect = urlParams.get('redirect')

    if (!user.require_password_change_on_next_login) {
      if (!isMentor) {
        await Promise.all([
          dispatch(fetchPoliciesIfNeeded()),
          dispatch(fetchUserCourses(user.id, false, false, isMentor)),
          dispatch(fetchUserCourses(user.id, false, true, isMentor)), // need to fetch past courses too
          dispatch(fetchUsers()),
          dispatch(fetchManifest()),
          dispatch(fetchArtifactAssessmentCriteria()),
          dispatch(fetchUnreadAnnouncementsCount()),
          dispatch(fetchAcademicYears()),
          dispatch(fetchClassPeriods()),
          dispatch(fetchClassRooms()),
          // this is needed to populate initial unread notifications count shown on myquests nav
          dispatch(fetchMyQuests(true))
        ])

        if (acceptedPoliciesCount !== 0) {
          dispatch(userIsLoggedInDataFetched())
          dispatch(userIsLoggedInRedirected())
          dispatch(push(redirect || `/user/${user.id}/dashboard`))
        }
      } else {
        await Promise.all([
          dispatch(fetchPoliciesIfNeeded()),
          dispatch(fetchUserCourses(user.id, false, false, isMentor)),
          dispatch(fetchUserCourses(user.id, false, true, isMentor)), // need to fetch past courses too
          dispatch(fetchUsers()),
          dispatch(fetchMentorNotifications()),
          dispatch(fetchManifest()),
          dispatch(fetchArtifactAssessmentCriteria()),
          dispatch(fetchAcademicYears()),
          dispatch(fetchClassPeriods()),
          dispatch(fetchClassRooms())
        ])

        const state = getState()
        const savedCourseId = localStorage.getItem('courseId')

        // only set these filters if the user is logging in to the same org as last login
        if (
          parseInt(localStorage.getItem('lastSelectedOrgId')) ===
            currentOrg.id &&
          savedCourseId
        ) {
          const courseToDefaultTo = state.usercourses.currentUserCourses.find(
            course => {
              return course.id === parseInt(savedCourseId)
            }
          )

          // only dispatch setting of course filter if currentUserCourses contains the course id
          if (courseToDefaultTo) {
            dispatch(setCourseFilter(parseInt(savedCourseId)))
          }
        }

        if (acceptedPoliciesCount !== 0) {
          dispatch(userIsLoggedInDataFetched())
          dispatch(userIsLoggedInRedirected())
          dispatch(
            push(
              isGuardian
                ?'/guardianlobby'
                : redirect || state.auth.userHasCurrentCourses
                ? '/mystudents/journeyoverview'
                : state.auth.userHasPastCourses
                ? '/mentordashboard'
                : '/mycommunity'
            )
          )
        }
      }
    } else {
      dispatch(userNeedsToResetPassword(true))
      dispatch(showModal('CHANGE_PASSWORD', {}))
    }
  }
}
